export const ContentBlocksText = {
    verifyBlockHeadingText: {
        english: 'Take advantage of additional features',
        spanish: 'Aproveche las funciones adicionales'
    },
    verifyBlockBodyText: {
        english: 'Quickly verify your identity to secure confidential access to your private information, and enable additional features like claim status.',
        spanish: 'Verifique rápidamente su identidad para asegurar el acceso confidencial a su información privada y habilite funciones adicionales como el estado de la reclamación.'
    },
    verifyBlockLinkText: {
        english: 'Verify my identity',
        spanish: 'Verificar mi identidad'
    },
    commPrefBlockHeadingText: {
        english: 'For text notifications',
        spanish: 'Inscríbase para las notificaciones por mensaje de texto'
    },
    commPrefBlockBodyText: {
        english: 'Update alerts and notifications under your profile to receive claim status texts.',
        spanish: 'Actualice las alertas y notificaciones en su perfil para recibir mensajes de texto sobre el estado de su reclamo.'
    },
    commPrefBlockLinkText: {
        english: 'Update my preferences',
        spanish: 'Actualizar mis preferencias'
    },
    wellnessBlockHeadingText: {
        english: 'Improve your financial wellness!',
        spanish: 'Mejora tu salud financiera'
    },
    wellnessBlockBodyText: {
        english: <>Using Lincoln’s new financial wellness tool, <i>WellnessPATH</i>®, determine your financial goals, track your progress, and improve your overall financial health.</>,
        spanish: <>Usando la herramienta de bienestar financiero de Lincoln, <i>WellnessPath</i>®, establezca sus metas financieras, haga un seguimiento de su proceso y ayude a mejorar su salud financiera general.</>
    },
    wellnessBlockLinkText: {
        english: 'Begin your short assessment with ',
        spanish: 'Comience su evaluación breve con '
    },
};
